import { render, staticRenderFns } from "./PatientTasks.vue?vue&type=template&id=2f363294"
import script from "./PatientTasks.vue?vue&type=script&lang=js"
export * from "./PatientTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports